import { render, staticRenderFns } from "./elevator-maintenance-detail.vue?vue&type=template&id=0107f530&scoped=true&"
import script from "./elevator-maintenance-detail.vue?vue&type=script&lang=js&"
export * from "./elevator-maintenance-detail.vue?vue&type=script&lang=js&"
import style0 from "./elevator-maintenance-detail.vue?vue&type=style&index=0&id=0107f530&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0107f530",
  null
  
)

export default component.exports